import { useEffect, useMemo, useState } from "react";
import "./AdminUpdatesPopup.css";

const ADMIN_UPDATE = {
  version: "2026-02-26-01",
  title: "Ultimas atualizacoes",
  publishedAt: "26/02/2026",
  items: [
    "Adicionado aguardando confirmação para os boletos, e visivel pa pagina do licenciado",
  ],
};

function getSeenKey(user) {
  const userKey = user?.id || user?.email || "admin";
  return `admin_updates_seen:${String(userKey)}`;
}

const AdminUpdatesPopup = ({ user }) => {
  const [open, setOpen] = useState(false);

  const storageKey = useMemo(() => getSeenKey(user), [user]);

  useEffect(() => {
    try {
      const lastSeenVersion = localStorage.getItem(storageKey);
      if (lastSeenVersion !== ADMIN_UPDATE.version) {
        setOpen(true);
      }
    } catch (_err) {
      setOpen(true);
    }
  }, [storageKey]);

  const fechar = () => {
    try {
      localStorage.setItem(storageKey, ADMIN_UPDATE.version);
    } catch (_err) {
      // sem bloqueio se localStorage estiver indisponivel
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="admin-updates-backdrop" onMouseDown={fechar}>
      <div className="admin-updates-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="admin-updates-header">
          <div>
            <h3>{ADMIN_UPDATE.title}</h3>
            <p>Publicacao: {ADMIN_UPDATE.publishedAt}</p>
          </div>
          <button
            type="button"
            className="admin-updates-close"
            onClick={fechar}
            aria-label="Fechar atualizacoes"
          >
            x
          </button>
        </div>

        <ul className="admin-updates-list">
          {ADMIN_UPDATE.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <div className="admin-updates-actions">
          <button type="button" className="admin-updates-ok" onClick={fechar}>
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminUpdatesPopup;
